import services from "../service";

export default {
    getSGAInfo(){
        return services.get('/sga/info');
    },
    registerMember(hash, key) {
        return services.post('/sga/GA00000002/register', { hash, key});
    },
    pollVote(hash, value, key){
        return services.post('/sga/GA00000002', {
            hash: hash,
            value: value,
            key: key
        });
    },

}
